import React from 'react';
import clsx from 'clsx';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import IconButton from '@mui/material/IconButton';
import ToolTip from 'core/components/Tooltip';
import {
  FieldComponentProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import {
  DeleteIcon,
} from 'core/icons';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';
import PatientHistoryAutoComplete from 'views/EMR/components/PatientHistoryAutoComplete';

export default function MedicalHistoryInfo({
  showLabel,
  index,
  onDelete,
  prefix,
}: FieldComponentProps) {
  const dltBtnClasses = clsx({ '!mt-4': showLabel });
  const { control } = useFormContext();
  const key = `${prefix}.${index}`;

  return (
    <div className="flex items-center gap-4">
      <Controller
        name={`${key}.conditionName`}
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { invalid } }) => (
          <Wrapper
            id="medicalHistorySettings"
            label={showLabel ? 'Past Medical History' : ''}
            className="w-full"
            error={invalid}
            showErrorText={false}
            required={showLabel}
          >
            <PatientHistoryAutoComplete
              {...field}
              id="medicalHistorySettings"
              keyName="conditionName"
              placeholder="Past Medical History"
            />
          </Wrapper>
        )}
      />
      <ToolTip title="Delete">
        <span>
          <IconButton
            className={dltBtnClasses}
            onClick={() => { onDelete(index); }}
            color="error"
          >
            <DeleteIcon className="text-gray-400 !w-5 !h-5" />
          </IconButton>
        </span>
      </ToolTip>
    </div>
  );
}
